"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCountryBankTypeToString = transformCountryBankTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformCountryBankTypeToString(countryBankType) {
    switch (countryBankType) {
        case legacy_enums_1.CountryBankType.BIC:
            return "BIC";
        case legacy_enums_1.CountryBankType.IBAN:
            return "IBAN";
        case legacy_enums_1.CountryBankType.US:
            return "US";
        default:
            return "-";
    }
}
//# sourceMappingURL=transformCountryBankTypeToString.js.map